import { render, staticRenderFns } from "./BaseDownIcon.vue?vue&type=template&id=67218b90"
import script from "./BaseDownIcon.vue?vue&type=script&lang=js"
export * from "./BaseDownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports